import {mapGetters} from "vuex"

export default {
  watch: {
    is_cart_with_estimate(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.$router.replace({
          name: this.is_cart_with_estimate ? "cart" : "cart_new"
        });
      }
    }
  },
  computed: {
    ...mapGetters(['is_cart_with_estimate']),
  },
};
